import { render, staticRenderFns } from "./LeadAppointments.vue?vue&type=template&id=a201ff80&scoped=true&"
import script from "./LeadAppointments.vue?vue&type=script&lang=js&"
export * from "./LeadAppointments.vue?vue&type=script&lang=js&"
import style0 from "./LeadAppointments.vue?vue&type=style&index=0&id=a201ff80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a201ff80",
  null
  
)

export default component.exports